import { useTranslations } from "next-intl";
import { useFiltersList } from "@hooks/use-features";
import SectionButton from "./Elements/SectionButton";
import SectionContent from "./Elements/SectionContent";
import FilterCheckbox from "./Elements/FilterCheckbox";

const filterSectionKey = "accessories";

function AccessoriesSection({
  categoryItems,
  refineCategory,
  onClose,
  filterSectionOpened,
  setFilterSectionOpened,
}) {
  const t = useTranslations("catalog");

  const filtersList = useFiltersList();

  const sectionTitle = t(`filters.section_titles.${filterSectionKey}`);
  const accessoriesItems = categoryItems.filter((item) =>
    filtersList.accessories.includes(item.value),
  );

  if (accessoriesItems.length < 1) return null;

  function displayAccessoriesFiltersOptions() {
    return filtersList.accessories.map((filter) => {
      const item = categoryItems.find((categoryItem) => categoryItem.value === filter);

      if (!item) return;

      return (
        <FilterCheckbox
          key={`filter-${filter}`}
          label={t(`filters.accessories.${filter}`)}
          filterType="accessories"
          filterSectionKey="category"
          item={item}
          refine={refineCategory}
        />
      );
    });
  }

  const checkedFilters = {
    accessories: filtersList.accessories.filter(
      (accessory) => categoryItems.find((item) => item.value === accessory)?.isRefined,
    ),
  };

  return (
    <div className="bg-white">
      <SectionButton
        checkedFilters={checkedFilters}
        filterTypesToDisplay={["accessories"]}
        title={sectionTitle}
        onClick={() => setFilterSectionOpened(filterSectionKey)}
      />

      <SectionContent
        isOpen={filterSectionOpened === filterSectionKey}
        onClose={onClose}
        onGoBack={() => setFilterSectionOpened("category")}
        title={sectionTitle}
        isSectionInsideSection
      >
        {displayAccessoriesFiltersOptions()}
      </SectionContent>
    </div>
  );
}

export default AccessoriesSection;
